import gt from "common/analytics/google-tagmanager";

import {
  generateEmployeeTrackingFunctions,
  generateDateTrackingFunctions,
  generateTimeTrackingFunctions
} from "site/page/views/tracking/tracking-factories";

const CATEGORY = "availability";

function addService (category) {
  return gt.trackEventAsync({
    category,
    property: "additional_services_button",
    action: "click"
  });
}

function checkoutClick () {
  return gt.trackEventAsync({
    category: CATEGORY,
    property: "continue_button",
    action: "click"
  });
}

function removeSku (category) {
  return gt.trackEventAsync({
    category,
    property: "remove_service_cross",
    action: "click"
  });
}

function initialPrice (value) {
  return gt.trackEventAsync({
    category: CATEGORY,
    property: "basket_price",
    action: "page_open",
    value: value
  });
}


export default {
  employeeSelection: generateEmployeeTrackingFunctions(CATEGORY),
  dateSelection: generateDateTrackingFunctions(CATEGORY),
  timeSelection: generateTimeTrackingFunctions(CATEGORY),
  basketSummary: {
    addService,
    checkoutClick,
    removeSku,
    initialPrice
  }
};
